module.exports = __webpack_public_path__ + "static/media/menu-white.bd68723f.png";